import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Dashboard.api';

export const getEmployeeCountRequest = () => ({
  type: actionTypes.GET_EMPLOYEE_COUNT_REQUEST,
});

export const getEmployeeCountSuccess = (employee_count) => ({
  type: actionTypes.GET_EMPLOYEE_COUNT_SUCCESS,
  payload: employee_count,
});

export const getEmployeeCountFailure = (error) => ({
  type: actionTypes.GET_EMPLOYEE_COUNT_FAILURE,
  payload: error,
});

export const getEmployeeCount = () => {
  return async (dispatch) => {
    dispatch(getEmployeeCountRequest());
    try {
      const employee_count = await api.fetchEmployeeCount();
      dispatch(getEmployeeCountSuccess(employee_count));
      return { success: true, data: employee_count };
    } catch (error) {
      dispatch(getEmployeeCountFailure(error));
      return { success: false, message: error };
    }
  };
};

export const getLogActivitiesRequest = () => ({
  type: actionTypes.GET_LOG_ACTIVITY_REQUEST,
});

export const getLogActivitiesSuccess = (log_activies) => ({
  type: actionTypes.GET_LOG_ACTIVITY_SUCCESS,
  payload: log_activies,
});

export const getLogActivitiesFailure = (error) => ({
  type: actionTypes.GET_LOG_ACTIVITY_FAILURE,
  payload: error,
});

export const getLogActivities = () => {
  return async (dispatch) => {
    dispatch(getLogActivitiesRequest());
    try {
      const log_activies = await api.fetchLogActivities();
      dispatch(getLogActivitiesSuccess(log_activies));
      return { success: true, data: log_activies };
    } catch (error) {
      dispatch(getLogActivitiesFailure(error));
      return { success: false, message: error };
    }
  };
};



export const getUpcomingHolidaysRequest = () => ({
  type: actionTypes.GET_UPCOMING_HOLIDAYS_REQUEST,
});

export const getUpcomingHolidaysSuccess = (upcoming_holidays) => ({
  type: actionTypes.GET_UPCOMING_HOLIDAYS_SUCCESS,
  payload: upcoming_holidays,
});

export const getUpcomingHolidaysFailure = (error) => ({
  type: actionTypes.GET_UPCOMING_HOLIDAYS_FAILURE,
  payload: error,
});

export const getUpcomingHolidays = () => {
  return async (dispatch) => {
    dispatch(getUpcomingHolidaysRequest());
    try {
      const upcoming_holidays = await api.fetchUpcomingHolidays();
      dispatch(getUpcomingHolidaysSuccess(upcoming_holidays));
      return { success: true, data: upcoming_holidays };
    } catch (error) {
      dispatch(getUpcomingHolidaysFailure(error));
      return { success: false, message: error };
    }
  };
};




